<template>
  <v-container
    fluid
    class="py-12 px-12 black"
  >
    <v-row
      class="pt-12"
    >
      <v-col
        cols="12"
        class="text-center"
      >
        <h2 class="display-1 font-weight-bold pt-0">
          <span class="barlow primary--text">TREINADORES E TERAPEUTAS</span>
        </h2>
      </v-col>
    </v-row>
    <v-row
      class="pt-6 pb-12 justify-center"
    >
      <v-col
        cols="12" md="4"
        v-for="(t,i) in terapeutas"
        :key="i"
        class="pt-12"
      >
        <v-card
          outlined dark
          class="fill-height text-center"
        >
          <v-avatar
            size="200" class="transparent mt-n12"
          >
            <v-img
              :src="getImg(t.imagem)"
              :alt="t.nome"
              color="transparent"
            >
            </v-img>
          </v-avatar>
          <v-card-title 
            class="headline pt-3 pb-2 justify-center white--text text-uppercase"
          >
            <span class="barlow font-weight-medium">{{t.nome}}</span>
          </v-card-title>
          <v-card-text
            class="grey--text"
          >
            <span class="body-2" v-html="t.miniBio"></span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      terapeutas: [
        {
          imagem: 'tadeu.png',
          nome: 'Tadeu Belfort',
          miniBio: 'Professor de Pós-graduação, Psicanalista Clínico, Terapeuta Sistêmico, Terapeuta Integrativo, Terapeuta Transgeracional, Trainer em PNL e Neurossemântica certificado pela International Socyety of Neuro-Semantics - ISNS e Master Trainer em Psicologia Positiva certificado pela European Positive Psychology Academy - EUPPA. Administrador de Empresas, Teólogo e Filósofo com especialização em Psicologia da Religião, Psicologia Junguiana, Psicologia Positiva e Gestão de Pessoas. Mestre e Doutor em Hipnose Clínica.'
        },
      ]
    }
  },
  methods: {
    getImg(i) {
      return require('@/assets/img/terapeutas/'+i)
    }
  }
}
</script>